import * as yup from 'yup'
import { IntlShape } from 'react-intl'
import { INewDriverStep1 } from 'features/Drivers/types'
import { driverPersonaInformationSchema } from 'features/Drivers/components/DriverPersonalInformationFormCard/schema'

export const driverStep1Schema = (intl: IntlShape): yup.SchemaOf<INewDriverStep1> => {
  return yup.object().shape(
    {
      ...driverPersonaInformationSchema(intl).fields,
      type: yup.string().optional()
    },
    [
      ['password', 'confirmPassword'],
      ['phone', 'email'],
      ['email', 'phone']
    ]
  )
}
